(function(angular) {
    angular.module('bizPartEngage').service('core.users.service', userService);

    userService.$inject = ["$http", "$window"];

    function userService($http, $window) {
        this.Logout = function() {
            $http.post(siteRootPath + "api/user/logout", {}).then(function(response) {
                deleteStorage("BizPartAuthToken");
                if (response.data) {
                    window.location.href = response.data;
                } else {
                    window.location.href = siteRootPath;
                }
                
                //$window.location.reload();
            }, function() {
                //PROBABLY ALREADY LOGGED OUT...
            	window.location.href = siteRootPath;
                //$window.location.reload();
            });
        };

        this.AddUserActivity = function (url, refererUrl, activityGroup) {
            return $http.post(siteRootPath + 'api/user/AddUserActivity', {url: url,refererUrl: refererUrl,activityGroup: activityGroup});
        };

        this.GetLoggedInUserDefaultLevelProgress = function() {
            return $http.get(siteRootPath + 'api/user/GetLoggedInUserDefaultLevelProgress');
        };

        this.GetLoggedInUserNotifications = function(max, page) {
            return $http.get(siteRootPath + 'api/user/GetLoggedInUserNotifications?' + $.param({ max: max, page: page }));
        };

        this.SaveMyProfile = function(user) {
            return $http.post(siteRootPath + 'api/user/SaveMyProfile', user);
        };

        this.GetUserGenericCustomFields = function (user) {
            return $http.get(siteRootPath + 'api/user/GetUserGenericCustomFields');
        };

        this.GetCustomFieldValue = function (customFieldId, objectId) {
            return $http.get(siteRootPath + 'api/user/GetCustomFieldValue?' + $.param({ customFieldId: customFieldId, objectId: objectId }));
        };

        this.UpdateCustomFieldValue = function (customFieldId, objectId, value) {
        	return $http.get(siteRootPath + 'api/user/UpdateCustomFieldValue?' + $.param({ customFieldId: customFieldId, objectId: objectId, value: value }));
        };

        this.UpdateMyPassword = function(password, oldPassword) {
        	return $http.post(siteRootPath + 'api/user/UpdateMyPassword', {password: password, oldPassword: oldPassword });
        };

        this.DeleteMe = function() {
            return $http.delete(siteRootPath + 'api/user/DeleteMe');
        }

        this.UpdateAllowSMSForLoggedInUser = function(allowSms) {
            return $http.post(siteRootPath + 'api/user/UpdateAllowSMSForLoggedInUser', allowSms);
        };

        this.GetLoggedInUserSetting = function(key) {
            return $http.get(siteRootPath + 'api/user/GetLoggedInUserSetting?' + $.param({key: key}));
        };

        this.GetLoggedInUserSettingAsBoolean = function(key) {
            return $http.get(siteRootPath + 'api/user/GetLoggedInUserSettingAsBoolean?' + $.param({ key: key }));
        };

        this.GetLoggedInUser = function () {
            return $http.get(siteRootPath + 'api/user/GetLoggedInUser');
        };

        this.GetLoggedInUserFromDB = function () {
            return $http.get(siteRootPath + 'api/user/GetUser');
        };

        this.GetProfile = function () {
            return $http.get(siteRootPath + 'api/profile/GetProfile');
        };

        this.GetProfileRestrictedFields = function () {
            return $http.get(siteRootPath + 'api/profile/GetRestrictedFields');
        };

        this.SaveBasicProfile = function(user) {
        	return $http.post(siteRootPath + 'api/profile/SaveBasicProfile', user);
        };

        this.SaveCustomProfileData = function(user) {
        	return $http.post(siteRootPath + 'api/profile/SaveCustomProfileData', user);
        };

        this.UpdateUserSession = function() {
            return $http.get(siteRootPath + "api/user/UpdateUserSession");
        };
         
        this.GetUserLogStats = function () {
            return $http.get(siteRootPath + 'api/EngageObjectStatistics/GetUserLogStats');
        };
        this.GetUserTypes = function () {
            return $http.get(siteRootPath + 'api/usertype/GetUserTypes');
        }
        this.SubscribeToNewsletter = function (key, email) {
            return $http.get(siteRootPath + 'api/user/SubscribeToNewsletter?' + $.param({ key: key, email: email }));
        };
        this.GetGenders = function () {
            return $http.get(siteRootPath + 'api/user/GetGenders');
        };
    }
})(window.angular);
